import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { ROLEPLAY_SERVICE } from "./service-url";

@Injectable({
  providedIn: 'root',
})
export class AvatarService {
  private clientId: string;
  private enableAvatarSessionActive = new Subject<boolean>();
  avatarActiveObservable$ = this.enableAvatarSessionActive.asObservable();


  constructor(private http: HttpClient) {}

  setClientId(clientId: string) {
    this.clientId = clientId;
  }

  setChatStatus(value: boolean) {
    this.enableAvatarSessionActive.next(value);
  }


  getIceToken(): Observable<any> {
    return this.http.get('http://10.49.244.88:7000/api/getIceToken');
  }

  connectAvatarService(localSdp: string, headers: any): Observable<string> {
    const httpHeaders = new HttpHeaders(headers);
    return this.http.post('http://10.49.244.88:7000/api/connectAvatar', localSdp, { headers: httpHeaders, responseType: 'text' });
  }

  // connectAvatarService(peerConnection: RTCPeerConnection, avatarConfig: any): Observable<any> {
  //   const localSdp = btoa(JSON.stringify(peerConnection.localDescription));
  //   const headers = {
  //     'ClientId': this.clientId,
  //     ...avatarConfig
  //   };

  //   return this.http.post('http://10.49.244.88:7000/api/connectAvatar', localSdp, { headers, responseType: 'text' });
  // }

  speak(spokenSsml: string): Observable<any> {
    const headers = {
      'ClientId': this.clientId,
      'Content-Type': 'application/ssml+xml'
    };
    return this.http.post('http://10.49.244.88:7000/api/speak', spokenSsml, { headers, responseType: 'text' });
  }

  stopSpeaking(): Observable<any> {
    const headers = {
      'ClientId': this.clientId
    };
    return this.http.post('http://10.49.244.88:7000/api/stopSpeaking', '', { headers });
  }

  disconnectAvatar(): Observable<any> {
    const headers = {
      'ClientId': this.clientId
    };
    return this.http.post('http://10.49.244.88:7000/api/disconnectAvatar', '', { headers });
  }

  getAvatarVoiceList(): Observable<any> {
    return this.http.get(ROLEPLAY_SERVICE.getAvatarVoiceList);
  }

  getAvatarVoiceListByGender(selectedVoiceType: string): Observable<any> {
    return this.http.get(ROLEPLAY_SERVICE.getAvatarVoiceListByGender + `${selectedVoiceType}`);
  }

}
